import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import * as styles from './style'

export interface Props {
  toggle: () => void
}

/**
 * This widget is used to provide feedback to a learner when they have successfully booked multiple sessions at once.
 */
const BookingConfirmation = ({ toggle }: Props): JSX.Element => {
  const { t } = useTranslation(['classes', 'common'])

  return (
    <>
      <span className={`${styles.successIcon} mb-md`}>
        <Icon name="double-tick" size={42} color="white" />
      </span>
      <Text tag="div" size="sm" weight="lg" responsiveSize={{ md: 'md', lg: 'lg' }}>
        {t('classes:bookMultipleSessionsSuccess.title')}
      </Text>
      <Text tag="div" size="xs" weight="sm" className="mb-md">
        {t('classes:bookMultipleSessionsSuccess.subtitle')}
        <Link href="/schedule/my-schedule" className={styles.link}>
          <span>"{t('common:mySchedule.tabTitle')}"</span>
        </Link>
      </Text>
      <Stack x justifyContent="flex-start" className="pb-sm">
        <Icon name="tick" size={32} className={styles.tickIcon} color="var(--gsu-primary)" />
        <Text tag="div" size="xs" weight="sm" className="ml-sm">
          {t('classes:bookMultipleSessionsSuccess.feature-1')}
        </Text>
      </Stack>
      <Stack x justifyContent="flex-start" className="pb-sm">
        <Icon name="tick" size={32} className={styles.tickIcon} color="var(--gsu-primary)" />
        <Text tag="div" size="xs" weight="sm" className="ml-sm">
          {t('classes:bookMultipleSessionsSuccess.feature-2')}
        </Text>
      </Stack>
      <Stack x justifyContent="flex-start" className="pb-sm">
        <Icon name="tick" size={32} className={styles.tickIcon} color="var(--gsu-primary)" />
        <Text tag="div" size="xs" weight="sm" className="ml-sm">
          {t('classes:bookMultipleSessionsSuccess.feature-3')}
        </Text>
      </Stack>
      <Stack y className="mt-md" alignItems="center">
        <Button
          className={`${styles.button} mb-sm`}
          component="link"
          href="/schedule/my-schedule"
          iconLeft="calendar"
          iconSize={24}
          label={t('common:mySchedule.tabTitle')}
          onClick={toggle}
          theme="primaryOutline"
        />
        <Button theme="secondary" label={t('common:okay')} onClick={toggle} className={styles.button} />
      </Stack>
    </>
  )
}
export default BookingConfirmation
